<template>
  <div class="video-embedded">
    <iframe
      :src="mainVideoSource"
      type="text/html"
      frameborder="0" />
  </div>
</template>

<script>
const youtubeOptions = {
  enablejsapi: 1,
  controls: 0,
  modestbranding: 1,
  rel: 0,
};

export default {
  name: 'YoutubePlayer',
  props: {
    id: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    youtubeOptions() {
      return {
        ...youtubeOptions,
        ...this.options,
      };
    },
    mainVideoSource() {
      const options = Object.entries({ ...this.youtubeOptions, origin: window.location.origin })
        .map(([k, v]) => `${k}=${v}`).join('&');
      return `${window.location.protocol}//www.youtube.com/embed/${this.id}?${options}`;
    },
  },
};
</script>

<style lang='scss' scoped>
.video-embedded {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  iframe, object, embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .ytp-show-cards-title {
      display: none;
    }
  }
}
</style>
